import { adminHttpClient } from '../../commons/adminHttpClient'
import { ExpenseAttachment } from './expenseAttachment'
import { NamedItem } from 'domain/common/NamedItem'
import { ExpenseStatus } from 'domain/expenses/expenseStatus'
import { Moment } from 'moment'

export interface PriorExpense {
  expenseId: string
  serviceProvider: string
  expenseType: NamedItem
  approvedAmount: number
  approvedPurchasedDate: Moment
  status: ExpenseStatus
  isDuplicate: boolean
  matchCount: number
  expenseNumber: number
  attachments: ExpenseAttachment[]
}

export type PriorExpenseFilter = {
  pageNumber: number
  currentExpenseId: string
  pageSize: number
  searchValue: string
  orderBy: string
  orderDescending: boolean
}

const getPriorExpenses = (priorExpenseFilter: PriorExpenseFilter, pageNumber: number): Promise<PriorExpense[]> => {
  return adminHttpClient.get('/DocReview/PriorExpenses', { ...priorExpenseFilter, pageNumber: pageNumber })
}

export default getPriorExpenses
